import { render, staticRenderFns } from "./amount_button.vue?vue&type=template&id=73c3c67c&scoped=true&"
import script from "./amount_button.vue?vue&type=script&lang=js&"
export * from "./amount_button.vue?vue&type=script&lang=js&"
import style0 from "./amount_button.vue?vue&type=style&index=0&id=73c3c67c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c3c67c",
  null
  
)

export default component.exports